import React from 'react'
import { Button, Paper, Stack, Typography } from '@mui/material'
import CustomModal from 'src/components/customerinput/CustomModal'

export default function UndeliveredModal({ open, close, data }) {
    return (
        <div>
            <CustomModal heading="Undelivered Messages" open={open} close={close}>
                <Typography variant='h5'>
                    Some messages in your campaign were not delivered. Please review the possible reasons below before your next campaign
                </Typography>
                <Paper sx={{ border: "1px solid lightGrey", padding: "15px", mt: "20px", display: "flex", flexDirection: "column", gap: "10px" }}>
                    <Paper sx={{ border: "1px solid lightGrey", padding: "15px", }}>
                        <Stack direction="row" justifyContent="space-between">
                            <Typography variant="body2">No WhatsApp Account Found</Typography>
                            <Typography variant="h5">{data?.no_whatsapp_acc}</Typography>
                        </Stack>
                    </Paper>
                    <Paper sx={{ border: "1px solid lightGrey", padding: "15px", }}>
                        <Stack direction="row" justifyContent="space-between">
                            <Typography variant="body2">Spam Rate Limit Triggered</Typography>
                            <Typography variant="h5">{data?.spam_rate_limit}</Typography>
                        </Stack>
                        <Typography variant="caption" color="error">*The number of messages blocked due to spam detection by WhatsApp.</Typography>
                    </Paper>
                    <Paper sx={{ border: "1px solid lightGrey", padding: "15px", }}>
                        <Stack direction="row" justifyContent="space-between">
                            <Typography variant="body2">Media Upload Failures</Typography>
                            <Typography variant="h5">{data?.media_upload_error}</Typography>
                        </Stack>
                    </Paper>
                    <Paper sx={{ border: "1px solid lightGrey", padding: "15px", }}>
                        <Stack direction="row" justifyContent="space-between">
                            <Typography variant="body2">Message Initiation Failed</Typography>
                            <Typography variant="h5">{data?.init_failed || 0}</Typography>
                        </Stack>
                    </Paper>
                    <Paper sx={{ border: "1px solid lightGrey", padding: "15px", }}>
                        <Stack direction="row" justifyContent="space-between">
                            <Typography variant="body2">Ecosystem Issues Count</Typography>
                            <Typography variant="h5">{data?.eco_system_issue + (data?.meta_restricted || 0)}</Typography>
                        </Stack>
                        <Typography variant="caption" color="error">WhatsApp may limit the marketing messages customer receive based on your engagement, like how often customer read them and your inbox activity</Typography>
                    </Paper>
                    <Paper sx={{ border: "1px solid lightGrey", padding: "15px", }}>
                        <Stack direction="row" justifyContent="space-between">
                            <Typography variant="body2">Account Rate Limit Reached</Typography>
                            <Typography variant="h5">{data?.account_rate_limit}</Typography>
                        </Stack>
                        <Typography variant="caption" color="error">The number of messages blocked due to exceeding the account’s rate limit.</Typography>
                    </Paper>
                </Paper>
            </CustomModal>
        </div>
    )
}
